/**
 * Local (localhost/127.0.0.1): luôn dùng /login trên FE — tránh SSO auth-dev lệch mật khẩu.
 * Prod SSO: set REACT_APP_AUTH_URL=https://portal... và host không phải local.
 */
const isLocalHost = (): boolean => {
  if (typeof window === 'undefined') return false
  const h = window.location.hostname
  return h === 'localhost' || h === '127.0.0.1'
}

export function getLoginRedirectUrl(redirectPath?: string): string {
  const authBase = (process.env.REACT_APP_AUTH_URL || '').trim().replace(/\/$/, '')
  const path = redirectPath || (typeof window !== 'undefined' ? window.location.pathname : '/')
  if (authBase && !isLocalHost()) {
    return `${authBase}/login-all?hethong=nhansu&redirect_url=${encodeURIComponent(path)}`
  }
  return '/login'
}

export const USE_LOCAL_LOGIN =
  isLocalHost() || !(process.env.REACT_APP_AUTH_URL || '').trim()
